export enum ConfigurationProfiles {
  Simplified = 'Simplified',
  Advanced = 'Advanced',
}
